import { useMutation } from "@apollo/react-hooks";
import { ChoiceList, Modal } from "@shopify/polaris";
import React, { useCallback, useEffect, useReducer } from "react";
import { arrInvalid, handleError, reducerFn } from "../../helper";
import { useToastContext } from "../shared/ToastContext";
import { MARK_ORDER_LABEL } from "../../graphql/mutations";
import useTimeout from "../../hooks/useTimeout";

export default function TiktokMarkAsOrderLabel({
    open,
    onClose,
    value,
    refetch,
    orderIDs,
    handleCompleted,
}) {
    const [state, setState] = useReducer(reducerFn, {
        selected: ["no"],
    });

    const { setNotify, toggleToast } = useToastContext();

    const [setDelay] = useTimeout();
    const [markOrderlabel, { loading }] = useMutation(MARK_ORDER_LABEL, {
        onCompleted: () => {
            setNotify({ msg: "Update Order success", err: false });

            setDelay(() => {
                onClose && onClose();
                refetch && refetch();
                handleCompleted && handleCompleted();
            }, 2000);
        },
        onError: (err) => {
            setNotify({ msg: handleError(err?.toString()), err: true });
        },
    });

    useEffect(() => {
        const isValid = !!value?.isOrderLabel;

        if (isValid) {
            setState({ selected: ["yes"] });
        }
    }, [value?.isOrderLabel]);

    const handleSubmit = useCallback(() => {
        if (arrInvalid(orderIDs)) return;

        markOrderlabel({
            variables: {
                ids: orderIDs,
                isLabel:
                    state.selected?.length > 0 && state.selected[0] === "yes",
            },
        });
    }, [markOrderlabel, setNotify, toggleToast, orderIDs, state.selected]);

    const handleStateChange = useCallback((selected) => {
        setState({ selected });
    }, []);

    return (
        <Modal
            title="Mark as Tiktok Order Label"
            sectioned
            open={open}
            onClose={onClose}
            secondaryActions={[{ content: "Cancel", onAction: onClose }]}
            primaryAction={{
                content: "Submit",
                onAction: handleSubmit,
                loading: loading,
            }}
        >
            <ChoiceList
                choices={[
                    { value: "no", label: "No" },
                    { value: "yes", label: "Yes" },
                ]}
                selected={state.selected}
                title="Is Order Label"
                onChange={handleStateChange}
            />
        </Modal>
    );
}
